<template>
  <div class="history-chat">
    <!-- Search + Pagination -->
    <div class="controls">
      <div class="search-box">
        <input style="display: inline-block;" v-model="inputCari" placeholder="Cari tiket..." class="input-cari" />
        <button style="display: inline-block;" @click="carichatfun()">cari tiket</button>
      </div>
      <div class="pager">
        <button @click="goFirst" :disabled="currentPage === 1">«</button>
        <button @click="prevPage" :disabled="currentPage === 1">Prev</button>

        <span>Page {{ currentPage }} / {{ totalPages }}</span>

        <button @click="nextPage" :disabled="currentPage === totalPages">
          Next
        </button>
        <button @click="goLast" :disabled="currentPage === totalPages">
          »
        </button>

        <!-- <select v-model.number="perPage" >
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select> -->
      </div>
    </div>

    <!-- TABEL -->
    <div class="table-container">
      <!-- HEADER -->
      <div class="table-header table-row">
        <div class="col-no">No.</div>
        <div class="col-tiket">Kode Tiket</div>
        <div class="col-nama">Nama Pemberi Kerja</div>
        <div class="col-kategori">Kategori Permasalahan</div>
        <div class="col-tanggal">Tanggal Closed</div>
        <div class="col-closed">Closed By</div>
        <div class="col-aksi">Aksi</div>
      </div>

      <!-- BODY (VIRTUAL) -->
      <div class="table-body" v-if="isLoadingData">
        <div class="col-span">
          mohon tunggu sebentar, data sedang diambil.
        </div>
      </div>
      <RecycleScroller v-if="!isLoadingData" class="table-body" v-slot="{ item, index }" :items="allTickets"
        :item-size="48" key-field="no_tiket">
        <div class="table-row">
          <div class="col-no">
            {{ index + 1 + (currentPage - 1) * perPage }}
          </div>
          <div class="col-tiket">{{ item.no_tiket }}</div>
          <div class="col-nama">
            {{ item.pengaduan_status?.nama_perusahaan || "-" }}
          </div>
          <div class="col-kategori">
            {{ item.pengaduan_status?.kategori_nama || "-" }}
          </div>
          <div class="col-tanggal">{{ item.tanggal_ditutup || "-" }}</div>
          <div class="col-closed">{{ item.closer || "-" }}</div>
          <div class="col-aksi">
            <button @click="lihatTiket(item.no_tiket)">Lihat</button>
            <button @click="bukaTiket(item.no_tiket, item.id)">Buka</button>
          </div>
        </div>
      </RecycleScroller>
    </div>

    <!-- CHAT PANEL -->
    <div class="chat-panel">
      <h3>Chat log detail: {{ currentTiket || "-" }}</h3>

      <div class="messages" ref="messages">
        <div v-if="!currentMessage.length" class="no-chat">
          Pilih tiket untuk melihat chat
        </div>

        <div v-for="(m, i) in currentMessage" :key="i" class="msg" :class="m.role_id === 3 ? 'user' : 'agent'">
          <div class="msg-header">
            <small>{{ m.nama_user }}</small>
          </div>

          <div class="msg-body">
            <template v-if="cekTipeFile(m.message) === null">
              {{ m.message }}
            </template>

            <template v-else>
              <div class="file" @click="lihatFile(m.message)">
                {{ cekTipeFile(m.message).nama }}
              </div>
            </template>
          </div>

          <div class="msg-date">
            <small>{{ m.sent_at }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RecycleScroller } from "vue3-virtual-scroller";
import "vue3-virtual-scroller/dist/vue3-virtual-scroller.css";
import axios from "axios";
import { backend as be } from "@/assets/config/server.js";
import { getCookie } from "@/assets/config/cookie";
import Swal from "sweetalert2";

export default {
  name: "HistoryChat",
  components: { RecycleScroller },
  data() {
    return {
      allTickets: [],
      rawdata: [],
      indexed: false,
      inputCari: "",
      debouncedSearch: null,
      currentPage: 1,
      perPage: 100,
      rowHeight: 56,
      currentTiket: null,
      allMessages: {},
      currentMessage: [],
      filteredTickets: [],
      isLoading: false, // Tambah state untuk loading
      loginInfoGlobal: null,
      isLoadingData: false,
      totalPages: 0
    };
  },
  computed: {
    // totalPages() {
    //   return this.rawdata?.data.last_page;
    // },
    pagedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredTickets.slice(start, start + this.perPage);
    },
  },
  created() {
    this.debouncedSearch = this.debouncefun(() => this.applySearch(), 300);
  },
  async mounted() {
    await this.fetchTickets();
  },

  methods: {
    async fetchTickets() {
      this.loginInfoGlobal = JSON.parse(getCookie("loginInfo"))
      const token = this.loginInfoGlobal.token;

      this.isLoadingData = true
      try {
        const res = await axios.get(`${be}/api/tiket/closed?page=${this.currentPage}&q=${this.inputCari}`, {
          headers: { Authorization: `Bearer ${token}` },
        });


        //console.log(res)
        this.rawdata = res.data;
        this.allTickets = Array.isArray(res.data.data.data) ? res.data.data.data : [];

        this.totalPages = this.rawdata?.data.last_page

        //console.log(this.rawdata)
        this.allTickets.forEach((t) => {
          this.allMessages[t.no_tiket] = t.messages || [];
        });

        this.indexed = true;
        this.filteredTickets = [...this.allTickets];
        this.isLoadingData = false
        //this.currentPage = 1;
      } catch (err) {
        console.error("Gagal fetch tiket", err);
        Swal.fire({
          title: "Error",
          text: "Gagal memuat data tiket",
          icon: "error"
        });
        this.allTickets = [];
        this.filteredTickets = [];

        this.isLoadingData = false
      }
    },

    debouncefun(fn, delay = 300) {
      let timer = null;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
      };
    },

    applySearch() {
      const q = (this.inputCari || "").toLowerCase().trim();
      if (!q) {
        this.filteredTickets = [...this.allTickets];
      } else {
        this.filteredTickets = this.allTickets.filter(
          (t) => t._searchText && t._searchText.includes(q)
        );
      }
      this.currentPage = 1;

      if (
        this.currentTiket &&
        !this.filteredTickets.some((t) => t.no_tiket === this.currentTiket)
      ) {
        this.currentTiket = null;
        this.currentMessage = [];
      }
    },

    debouncedSearchCode() {
      this.debouncedSearch();
    },

    changePerPage() {
      this.currentPage = 1;
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;

      }
      this.fetchTickets()
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--

      }
      this.fetchTickets()
    },
    goFirst() {
      this.currentPage = 1;
      this.fetchTickets()
    },
    goLast() {
      this.currentPage = this.totalPages;
      this.fetchTickets()
    },

    async bukaTiket(no, id) {
      const sessionToken = this.loginInfoGlobal.token;

      const result = await Swal.fire({
        title: "Yakin ingin buka tiket ini?",
        text: `Tiket Nomor ${no} akan kembali dibuka!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Ya, Buka!",
        cancelButtonText: "Batal"
      });

      if (!result.isConfirmed) return;

      this.isLoading = true;

      try {
        const formData = new FormData();
        // Jika perlu data tambahan, bisa ditambahkan di sini
        // formData.append('key', 'value');

        const res = await axios.post(
          `${be}/api/tiket/${id}/set-open`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${sessionToken}`,
            },
          }
        );

        if (res.status === 200 || res.status === 201) {
          // Hapus tiket dari semua array
          this.allTickets = this.allTickets.filter(item => item.id !== id);
          this.filteredTickets = this.filteredTickets.filter(item => item.id !== id);

          // Reset selection jika tiket yang dibuka sedang dipilih
          if (this.currentTiket === no) {
            this.currentTiket = null;
            this.currentMessage = [];
          }

          // Hapus dari messages cache
          delete this.allMessages[no];

          await Swal.fire({
            title: "Berhasil!",
            text: `Tiket Nomor ${no} telah berhasil dibuka kembali`,
            icon: "success",
            timer: 2000,
            showConfirmButton: false
          });

          // Refresh data (opsional)
          // await this.fetchTickets();

        } else {
          throw new Error(res.data.message || 'Terjadi kesalahan');
        }
      } catch (error) {
        console.error("Error buka tiket:", error);

        let errorMessage = "Gagal membuka tiket. Silakan coba lagi.";
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || errorMessage;
        }

        await Swal.fire({
          title: "Gagal!",
          text: errorMessage,
          icon: "error"
        });
      } finally {
        this.isLoading = false;
      }
    },

    lihatTiket(no) {
      this.currentTiket = no;
      this.currentMessage = this.allMessages[no] || [];
      this.$nextTick(() => {
        const el = this.$refs.messages;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },

    cekTipeFile(nama) {
      if (!nama) return null;
      const lower = nama.toLowerCase();
      if (
        lower.includes("pengaduan_images") ||
        lower.includes("pengaduan_files")
      ) {
        const parts = lower.split("/");
        const fname = parts[parts.length - 1] || nama;
        const ext = fname.split(".").pop();
        if (ext === "pdf") return { type: "pdf", nama: fname };
        if (["jpg", "jpeg", "png", "webp"].includes(ext))
          return { type: "image", nama: fname };
      }
      return null;
    },

    lihatFile(namafile) {
      if (!namafile) return;
      window.open(`${be}/storage/${namafile}`, "_blank");
    },

    carichatfun() {
      this.currentPage = 1
      this.fetchTickets()
    }
  },
};
</script>

<style scoped>
.history-chat {
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 16px;
  height: calc(100vh - 20px);
  padding: 10px;
}

/* SEARCH + PAGINATION */
.controls {
  grid-column: 1 / span 2;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.controls .search-box {
  button {
    padding: 10px 15px;
    margin-left: 10px;
  }
}

.input-cari {
  width: 280px;
  padding: 8px;
  border: 1px solid #ccc;
}

.pager {
  display: flex;
  gap: 8px;
}

/* TABLE */
.table-container {
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  background: white;
  display: grid;
  grid-template-rows: max-content auto;
}

.table-row {
  display: grid;
  grid-template-columns: 5% 15% 30% 20% 10% 10% 10%;
  padding: 10px;
  height: min-content;
  white-space: nowrap;
  background-color: transparent;

  /* ⛔ PENTING: cegah teks meledak keluar */
  div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 11pt;
  }
}

.table-row div:nth-child(1) {
  text-align: center;
  background-color: transparent;
}

.table-row div:nth-child(2) {
  background-color: transparent;
}

.table-row div:nth-child(3) {
  background-color: transparent;
}

.table-row div:nth-child(4) {
  background-color: transparent;
}

.table-row div:nth-child(5) {
  background-color: transparent;
}

.table-row div:nth-child(6) {
  background-color: transparent;
  text-align: center;
}

.table-row div:nth-child(7) {
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: transparent;

  button {
    padding: 5px 15px;
    border-radius: 5px;
    background-color: #eee;
    border: none;
  }

  button:last-child {
    margin-left: 10px;
  }
}

.table-header {
  background: #f3f3f3;
  font-family: poppins-semi;
  text-align: center;
  padding-right: 25px;
  border-bottom: 1px solid #ddd;
}

.table-body {
  height: 100%;
  background-color: transparent;

  .col-span {
    width: max-content;
    background-color: #649aff4f;
    color: #1869ff;
    padding: 10px 15px;
    border-radius: 5px;
    margin-top: 15px;
    margin-left: 50%;
    transform: translateX(-50%);
  }
}

.table-body .table-row {
  border-bottom: 1px solid #eee;
}

.table-body .table-row:hover {
  background: #fafafa;
}



/* CHAT PANEL */
.chat-panel {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px;
  overflow: hidden;
}

.messages {
  height: calc(100vh - 180px);
  overflow-y: auto;
}

.no-chat {
  color: #777;
  padding-top: 20px;
  text-align: center;
}

.msg {
  margin-bottom: 10px;
}
</style>
